import { tourStep } from './tourRegistry';

export const bandaCalendarioSteps = [
  tourStep(
    'calendario-header',
    'Disponibilidad',
    'Aquí marcas qué días está libre la banda. Las cofradías lo consultan antes de escribirte.',
  ),
  tourStep(
    'calendario-compartir',
    'Compartir',
    'Genera un enlace o una imagen del calendario para enviarlo fuera de Cadencya.',
  ),
  tourStep(
    'calendario-modo',
    'Día o rango',
    'Individual marca un día. Rango selecciona varios seguidos y los pone ocupados o disponibles a la vez.',
  ),
  tourStep(
    'calendario-meses',
    'Mes a mes',
    'Recorre el año. También puedes filtrar ensayos y actuaciones que ya tienes en Gestión.',
    'top',
  ),
];
